import styled, { keyframes } from 'styled-components';
import media from '../theme/media';
import { fontSans, colorLink } from '../theme/config';

export const ButtonLink = styled.a`
  font-family: ${fontSans};
  background: linear-gradient(45deg, #418EE5, #5FACFB);
  box-shadow: 0 1px 3px 0 rgba(50,50,93,0.2);
  padding: 3px 18px;
  display: inline-block;
  border-radius: 4px;
  color: white;
  font-weight: 600;
  font-size: 18px;
  line-height: 36px;
  margin: 1.5rem 1.5rem 0 0;
  ${media.small`
    font-size: 1rem;
  `}
`;

export const ButtonShow = styled.button `
  color: #909AA3;
  display: block;
  font-size: 1rem;
  cursor: pointer;
  margin-bottom: .5rem;
  font-weight: 400;
  background-color: transparent;
  svg {
    vertical-align: middle;
    margin: 0 12px 0 0;
  }
  span {
    vertical-align: middle;
  }
  svg circle.dark {
    fill: #909AA3;
  }
  svg ellipse.light {
    fill: #CED4DA;
  }
  &.selected {
    color: #0077FF;
    svg circle.dark {
      fill: #0077FF;
    }
    svg ellipse.light {
      fill: #C0DDFF;
    }
  }
  &.mozilla.selected {
    color: #F50900;
    svg circle.dark {
      fill: #F50900;
    }
    svg ellipse.light {
      fill: #FFC1BF;
    }
  }
`;

const ButtonShift2 = keyframes `
  from { transform: translate3d(0,0,0);    }
  to   { transform: translate3d(100%,0,0); }
`;

const ButtonShift = keyframes `
  from { transform: translate3d(100%,0,0);    }
  to   { transform: translate3d(0,0,0); }
`;

export const ButtonToggle = styled.button `
  font-size: 1rem;
  font-weight: 500;
  line-height: 36px;
  color: ${colorLink};
  display: inline-block;
  cursor: pointer;
  background-color: transparent;
  border-radius: 0;
  padding: .25rem 0;
  margin-bottom: 0;
  width: fit-content;
  width: -moz-fit-content;
  position: relative;
  border-bottom: 1px solid #CED4DA;
  &:first-child {
    &::before {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background: ${colorLink};
      content: '';
      animation: ${ButtonShift} .3s linear;
      transform: translate3d(0,0,0);
    }
    &:first-child {
      &.true {
        &::before {
          animation: ${ButtonShift2} .3s linear;
          transform: translate3d(100%,0,0);
        }
      }
    }
  }
`;

export const ButtonToggleContainer = styled.div`
  margin: 4rem 0 2rem 0;
  width: fit-content;
  width: -moz-fit-content;
`;



// WEBPACK FOOTER //
// src/theme/buttons.js